export default __webpack_public_path__ + "static/media/tvinsure-sme-sabai-package-4.18abe08c.png";